import { useState, useMemo } from 'react';
import { Box, Wrap, WrapItem, HStack } from '@chakra-ui/react';
import { FaDollarSign } from 'react-icons/fa';
import { useRadio, useRadioGroup } from '@chakra-ui/radio';
import { Controller, useForm, useFormState } from 'react-hook-form';
import { Collapse } from '@chakra-ui/transition';
import { Input, InputGroup, InputLeftElement } from '@chakra-ui/input';
import Icon from '@chakra-ui/icon';
import { FormControl, FormLabel } from '@chakra-ui/form-control';
import map from 'lodash/map'
import reduce from 'lodash/reduce'

import Helper from '../../components/Helper';
import RadioCard from '../../components/FormField/RadioCard';
import { SUPPORT_MAX_AMOUNT, SUPPORT_MIN_AMOUNT } from '../../constants/support';

const PriceSelector = ({
  prices,
  enableCustomPrice,
  customPriceLabel,
  customPriceMessage,
  quickValue:
  outerQuickValue,
  setValue,
  control,
  isPreview,
}) => {
  const [localQuickValue, setLocalQuickValue] = useState(() => isPreview ? prices[0]?.price : undefined)
  const quickValue = outerQuickValue ?? localQuickValue
  const quickValueLabel = useMemo(() => reduce(prices, (labels, p) => {
    labels[p.price] = p.label
    return labels
  }, { custom: customPriceMessage || '隨喜支持！' }), [prices, customPriceMessage])
  const {
    getRootProps: getQuickRootProps,
    getRadioProps: getQuickRadioProps,
  } = useRadioGroup({
    name: 'quick',
    onChange: value => setValue ? setValue('quick', value) : setLocalQuickValue(value),
    value: quickValue,
  })

  const quickGroup = getQuickRootProps()
  return (
    <FormControl p="2" isRequired>
      <HStack>
        <FormLabel fontSize="1em" mb="3">
          支持金額
        </FormLabel>
      </HStack>
      <Wrap {...quickGroup} spacing="2">
        {map(prices, (value, i) => {
          const radio = getQuickRadioProps({ value: `${value.price}` })
          return (
            <WrapItem key={i}>
              <RadioCard {...radio}>
                ${value.price || ' - '}
              </RadioCard>
            </WrapItem>
          )
        })}
        {enableCustomPrice && (
          <WrapItem>
            <RadioCard {...getQuickRadioProps({ value: 'custom' })}>
              {customPriceLabel || '自訂'}
            </RadioCard>
          </WrapItem>
        )}

      </Wrap>
      <Box w="full">
        <Collapse in={quickValue === 'custom'} animateOpacity>
          {control && (
            <Controller
              control={control}
              name="amount"
              rules={{
                min: SUPPORT_MIN_AMOUNT,
                max: SUPPORT_MAX_AMOUNT,
                valueAsNumber: true,
              }}
              render={({ field }) => (
                <InputGroup mt="3">
                  <InputLeftElement pointerEvents="none">
                    <Icon as={FaDollarSign} size="1.25em" />
                  </InputLeftElement>
                  <Input min={SUPPORT_MIN_AMOUNT} max={SUPPORT_MAX_AMOUNT} type="number" placeholder="自訂金額" {...field} />
                </InputGroup>
              )}
            />
          )}
        </Collapse>
      </Box>

      <Collapse in={Boolean(quickValue)} animateOpacity>
        <Helper mt="2" color="primary.500">{quickValueLabel?.[quickValue]}</Helper>
      </Collapse>
    </FormControl>
  )
}

export default PriceSelector
